import React, { useState } from 'react';
import styled from 'styled-components';
import MonthlyPackages from './MonthlyPackages';
import YearlyPackages from './YearlyPackages';
// import YearlyPackages from './YearlyPackages';


const AllPackages = () => {

    // Sales Type Function
    const [type, settype] = useState('monthly');

    function changeType(e) {
        settype(e);
    }
    // Sales Type Function


    return (
        <>
            <StyledPackages>

                {/* Select buttons for Monthly or Yearly */}

                <div
                    className="d-flex transparent py-2 px-2 br-sm fit-content mx-auto mt-4 justify-content-between pry-border">
                    <div
                        className={`col br-sm py-1 pry-text pointer text-center px-3 ${ type === 'monthly' ? 'pry light-text ' : ('') } `}
                        onClick={e => changeType('monthly')}
                    >
                        Monthly
                    </div>
                    <div
                        className={`col br-sm py-1 pry-text pointer text-center px-3 ${ type === 'annually' ? 'pry light-text' : ('') } `}
                        onClick={e => changeType('annually')}
                    >
                        Annually
                    </div>
                </div>


                <p className='pry-bold-text text-center my-3'>
                    Only pay for 11 months, get one month for free when you choose Annually
                </p>

                {/* Select buttons for Monthly or Yearly */}

                {type === 'monthly' ?
                    <MonthlyPackages
                    /> :
                    <YearlyPackages
                    />
                }

            </StyledPackages>
        </>
    );
};

export default AllPackages;


const StyledPackages = styled.div`

`;